
import React from 'react';
import { convertStringToElements } from '@vds/html-parsers';
import { plansPageContinueButtonFFlag } from '../utils/globalConfig';
import PropTypes from 'prop-types';
import { Notification } from '@vds/notifications';

const PaygoNotification = ({ selectedDeviceDetails, devicesAndPlans }) => {


    return (
        <>{plansPageContinueButtonFFlag && (selectedDeviceDetails?.currentPlanDetails?.filter((plan) => plan?.monthlyITP === true || plan?.monthlyITPRecurring === true).length > 0) && devicesAndPlans?.payGoOnly &&
            <Notification
                type="warning"
                title={convertStringToElements(devicesAndPlans?.payGoMonthlyPlanText)}
                fullBleed={false}
                inline={false}
                disableFocus={true}
                hideCloseButton={true}
            />}
        </>

    )
}
PaygoNotification.propTypes = {
    selectedDeviceDetails: PropTypes.object,
    devicesAndPlans: PropTypes.object,
}
export default PaygoNotification;